<template>
  <div class="loading-container" aria-live="polite" :aria-busy="state === 'loading'">
    <loader v-if="state === 'loading'" :size="size" />
    <error-message v-if="state === 'error'" :msg=errormsg />
    <slot v-if="state === 'success'"></slot>
  </div>
</template>

<script lang="ts">
import ErrorMessage from '@/components/feedback/ErrorMessage.vue';
import Loader from '@/components/feedback/Loader.vue';
import { LoadingState } from '@/utils/loadingUtils';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'LoadingContainer',
  components: {
    Loader,
    ErrorMessage,
  },
  props: {
    errormsg: {
      type: String,
      required: false
    },
    state: String as PropType<LoadingState>,
    size: String
  }
});
</script>
<style scoped>
  .loading-container[aria-busy=true] {
    /* min-height: 200px; */
    align-items: center;
    display: flex;
    justify-content: center;
  }
</style>
